<div class="tracking-loads-container">
    <!-- Left Panel: Order List -->
    <div class="left-panel">
        <!-- Header -->
        <div class="panel-header">
            <h1 class="panel-title">Tracking Delivery</h1>
        </div>

        <!-- Search Box -->
        <div class="search-box">
            <mat-icon class="search-icon">search</mat-icon>
            <input type="text" [(ngModel)]="searchText" placeholder="Search" class="search-input" />
        </div>

        <!-- Filter Tabs -->
        <div class="filter-tabs">
            <button class="tab-btn" [class.active]="currentFilter === 'all'" (click)="currentFilter = 'all'">
                All Loads <span class="tab-count">{{ orders.length }}</span>
            </button>
            <button class="tab-btn" [class.active]="currentFilter === 'in-transit'" (click)="currentFilter = 'in-transit'">
                In-transit <span class="tab-count">{{ getFilteredCount('In Transit') }}</span>
            </button>
            <button class="tab-btn" [class.active]="currentFilter === 'delivered'" (click)="currentFilter = 'delivered'">
                Delivered <span class="tab-count">{{ getFilteredCount('Delivered') }}</span>
            </button>
            <button class="tab-btn-icon">
                <mat-icon>tune</mat-icon>
            </button>
        </div>

        <!-- Loading Overlay -->
        <div *ngIf="isLoading" class="loading-overlay">
            <mat-spinner diameter="40"></mat-spinner>
        </div>

        <!-- Order Cards List -->
        <div class="orders-list" *ngIf="!isLoading">
            <div *ngFor="let order of filteredOrdersList"
                 class="order-card"
                 [class.selected]="selectedOrder?.id === order.id"
                 (click)="selectOrder(order)">
                <!-- Card Header -->
                <div class="card-header">
                    <div class="order-icon-wrapper">
                        <mat-icon class="order-icon">inventory_2</mat-icon>
                    </div>
                    <span class="order-id">#{{ order.reference || order.id }}</span>
                    <span class="status-badge" [ngClass]="{
                        'status-in-transit': order.status === 'In-transit',
                        'status-delivered': order.status === 'Delivered'
                    }">{{ order.status }}</span>
                </div>

                <!-- Horizontal Progress Bar -->
                <div class="horizontal-progress">
                    <!-- Icons Row -->
                    <div class="progress-icons-row">
                        <!-- Pickup Icon -->
                        <div class="progress-marker" [class.completed]="order.trackingStatus?.pickUp?.completed">
                            <mat-icon>warehouse</mat-icon>
                        </div>

                        <!-- Destination Icon -->
                        <div class="progress-marker" [class.completed]="order.trackingStatus?.delivered?.completed">
                            <mat-icon>location_on</mat-icon>
                        </div>

                        <!-- Truck Icon (Dynamic Position) -->
                        <div *ngIf="+order.progress > 0"
                             class="progress-marker truck dynamic"
                             [style.left]="'calc(24px + ' + (+order.progress / 100) + ' * (100% - 48px))'">
                            <mat-icon>local_shipping</mat-icon>
                        </div>

                        <!-- Progress Fill Line -->
                        <div class="line-fill"
                             [style.width]="'calc(' + (+order.progress / 100) + ' * (100% - 48px))'"></div>
                    </div>

                    <!-- Labels Row -->
                    <div class="progress-labels-row">
                        <div class="progress-label label-start">Loaded</div>
                        <div class="progress-label label-end">Delivered</div>
                        <!-- <div class="progress-label label-start">{{ order.from.location }}</div>
                        <div class="progress-label label-end">{{ order.to.location }}</div> -->
                    </div>
                </div>

                <!-- Customer Info -->
                <div class="customer-info">
                    <img [src]="order.customer.image"
                         alt="{{ order.customer.name }}"
                         class="customer-avatar"
                         onerror="this.src='assets/images/default-profile.png'">
                    <div class="customer-details">
                        <span class="customer-name">{{ order.customer.name }}</span>
                        <span class="customer-label">Customer</span>
                    </div>
                    <div class="customer-actions">
                        <!-- <button class="action-btn" (click)="$event.stopPropagation()">
                            <mat-icon>email</mat-icon>
                        </button> -->
                        <button *ngIf="order.driver?.contactNumber"
                                class="action-btn"
                                (click)="$event.stopPropagation(); showCallDialog(order.driver.contactNumber)">
                            <mat-icon>phone</mat-icon>
                        </button>
                    </div>
                </div>
            </div>

            <!-- Empty State -->
            <div *ngIf="filteredOrdersList.length === 0" class="empty-state">
                <mat-icon>search_off</mat-icon>
                <p>No orders found</p>
            </div>
        </div>
    </div>

    <!-- Right Panel: Map -->
    <div class="right-panel">
        <!-- Map Container -->
        <div class="map-wrapper">
            <!-- Map Controls -->
            <div class="map-controls">
                <button class="map-control-btn" [class.active]="mapView === 'map'" (click)="mapView = 'map'">
                    Map
                </button>
                <button class="map-control-btn" [class.active]="mapView === 'satellite'" (click)="mapView = 'satellite'">
                    Satellite
                </button>
                <button class="map-control-btn layers-btn">
                    <mat-icon>layers</mat-icon>
                    Layers
                </button>
            </div>

            <!-- Google Map -->
            <google-map
                #map
                [options]="mapOptions"
                height="100%"
                width="100%"
                [center]="mapCenter"
                (mapClick)="onMapClick($event)">

                <!-- Markers for all orders -->
                <ng-container *ngFor="let order of orders">
                    <!-- Start Marker -->
                    <map-marker
                        [position]="{ lat: parseFloat(order.from.lat), lng: parseFloat(order.from.lng) }"
                        [options]="{ icon: getStartIcon(), zIndex: 10 }">
                    </map-marker>

                    <!-- Truck Marker -->
                    <map-marker
                        *ngIf="order.truckLocation"
                        [position]="{ lat: parseFloat(order.truckLocation.lat), lng: parseFloat(order.truckLocation.lng) }"
                        [options]="{ icon: getTruckIcon(), zIndex: 20 }">
                    </map-marker>

                    <!-- End Marker -->
                    <map-marker
                        [position]="{ lat: parseFloat(order.to.lat), lng: parseFloat(order.to.lng) }"
                        [options]="{ icon: getEndIcon(), zIndex: 10 }">
                    </map-marker>
                </ng-container>
            </google-map>

            <!-- Tracking Detail Panel (Floating over map) -->
            <div class="tracking-detail-panel" *ngIf="selectedOrder">
                <div class="detail-panel-header">
                    <div class="panel-title-section">
                        <span class="panel-label">No:</span>
                        <span class="panel-order-id">#{{ selectedOrder.reference || selectedOrder.id }}</span>
                    </div>
                    <div class="panel-actions">
                        <!-- <button class="panel-action-btn" (click)="copyOrderId()">
                            <mat-icon>content_copy</mat-icon>
                        </button>
                        <button class="panel-action-btn" (click)="editOrder()">
                            <mat-icon>edit</mat-icon>
                        </button>
                        <button class="panel-action-btn" (click)="deleteOrder()">
                            <mat-icon>delete</mat-icon>
                        </button> -->
                        <button class="panel-action-btn close-btn" (click)="closeDetailPanel()">
                            <mat-icon>close</mat-icon>
                        </button>
                    </div>
                </div>

                <!-- Tabs -->
                <!-- <div class="detail-tabs">
                    <button class="detail-tab" [class.active]="activeTab === 'load'" (click)="activeTab = 'load'">
                        Load info
                    </button>
                    <button class="detail-tab" [class.active]="activeTab === 'tracking'" (click)="activeTab = 'tracking'">
                        Tracking
                    </button>
                    <button class="detail-tab" [class.active]="activeTab === 'docs'" (click)="activeTab = 'docs'">
                        Docs
                    </button>
                </div> -->

                <!-- Tab Content -->
                <div class="detail-content">
                    <!-- Tracking Tab Content -->
                    <div *ngIf="activeTab === 'tracking'" class="tracking-timeline">
                        <!-- Pick Up -->
                        <div class="timeline-item" [class.completed]="selectedOrder.trackingStatus?.pickUp?.completed">
                            <div class="timeline-marker">
                                <div class="marker-dot">
                                    <mat-icon *ngIf="selectedOrder.trackingStatus?.pickUp?.completed">check</mat-icon>
                                    <span *ngIf="!selectedOrder.trackingStatus?.pickUp?.completed">1</span>
                                </div>
                                <div class="marker-line" [class.active]="selectedOrder.trackingStatus?.onTheWay?.completed"></div>
                            </div>
                            <div class="timeline-content">
                                <div class="timeline-header">
                                    <span class="timeline-title">{{ selectedOrder.trackingStatus?.pickUp?.status || 'Pick up' }}</span>
                                    <span class="timeline-badge" [class.active]="selectedOrder.trackingStatus?.pickUp?.completed">
                                        {{ selectedOrder.trackingStatus?.pickUp?.completed ? 'Completed' : 'Pending' }}
                                    </span>
                                </div>
                                <div class="timeline-location">
                                    <mat-icon>location_on</mat-icon>
                                    <span>{{ selectedOrder.trackingStatus?.pickUp?.location || selectedOrder.from?.location || 'N/A' }}</span>
                                </div>
                                <div class="timeline-datetime">
                                    <mat-icon>schedule</mat-icon>
                                    <span>{{ selectedOrder.trackingStatus?.pickUp?.date || 'Pending' }} {{ selectedOrder.trackingStatus?.pickUp?.time || '' }}</span>
                                </div>
                            </div>
                        </div>

                        <!-- On The Way -->
                        <div class="timeline-item" [class.completed]="selectedOrder.trackingStatus?.onTheWay?.completed">
                            <div class="timeline-marker">
                                <div class="marker-dot">
                                    <mat-icon *ngIf="selectedOrder.trackingStatus?.onTheWay?.completed">check</mat-icon>
                                    <span *ngIf="!selectedOrder.trackingStatus?.onTheWay?.completed">2</span>
                                </div>
                                <div class="marker-line" [class.active]="selectedOrder.trackingStatus?.delivered?.completed"></div>
                            </div>
                            <div class="timeline-content">
                                <div class="timeline-header">
                                    <span class="timeline-title">{{ selectedOrder.trackingStatus?.onTheWay?.status || 'On the way' }}</span>
                                    <span class="timeline-badge" [class.active]="selectedOrder.trackingStatus?.onTheWay?.completed">
                                        {{ selectedOrder.trackingStatus?.onTheWay?.completed ? 'Completed' : 'Pending' }}
                                    </span>
                                </div>
                                <div class="timeline-location">
                                    <mat-icon>local_shipping</mat-icon>
                                    <span>{{ selectedOrder.trackingStatus?.onTheWay?.location || 'In transit' }}</span>
                                </div>
                                <div class="timeline-datetime">
                                    <mat-icon>schedule</mat-icon>
                                    <span>{{ selectedOrder.trackingStatus?.onTheWay?.date || 'In progress' }} {{ selectedOrder.trackingStatus?.onTheWay?.time || '' }}</span>
                                </div>
                            </div>
                        </div>

                        <!-- Delivered -->
                        <div class="timeline-item last" [class.completed]="selectedOrder.trackingStatus?.delivered?.completed">
                            <div class="timeline-marker">
                                <div class="marker-dot">
                                    <mat-icon *ngIf="selectedOrder.trackingStatus?.delivered?.completed">check</mat-icon>
                                    <span *ngIf="!selectedOrder.trackingStatus?.delivered?.completed">3</span>
                                </div>
                            </div>
                            <div class="timeline-content">
                                <div class="timeline-header">
                                    <span class="timeline-title">{{ selectedOrder.trackingStatus?.delivered?.status || 'Delivered' }}</span>
                                    <span class="timeline-badge" [class.active]="selectedOrder.trackingStatus?.delivered?.completed">
                                        {{ selectedOrder.trackingStatus?.delivered?.completed ? 'Completed' : 'Pending' }}
                                    </span>
                                </div>
                                <div class="timeline-location">
                                    <mat-icon>flag</mat-icon>
                                    <span>{{ selectedOrder.trackingStatus?.delivered?.location || selectedOrder.to?.location || 'N/A' }}</span>
                                </div>
                                <div class="timeline-datetime">
                                    <mat-icon>schedule</mat-icon>
                                    <span>{{ selectedOrder.trackingStatus?.delivered?.date || 'Pending' }} {{ selectedOrder.trackingStatus?.delivered?.time || '' }}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Load Info Tab Content -->
                    <div *ngIf="activeTab === 'load'" class="load-info-content">
                        <p class="placeholder-text">Load information will be displayed here</p>
                    </div>

                    <!-- Docs Tab Content -->
                    <div *ngIf="activeTab === 'docs'" class="docs-content">
                        <p class="placeholder-text">Documents will be displayed here</p>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>

<!-- Call Dialog -->
<div class="call-dialog-overlay" *ngIf="callDialogNumber" (click)="callDialogNumber = null">
    <div class="call-dialog" (click)="$event.stopPropagation()">
        <div class="call-dialog-icon">
            <mat-icon>phone</mat-icon>
        </div>
        <p class="call-dialog-label">Driver Contact</p>
        <p class="call-dialog-number">{{ callDialogNumber }}</p>
        <div class="call-dialog-actions">
            <button class="call-dialog-btn cancel" (click)="callDialogNumber = null">Cancel</button>
            <button class="call-dialog-btn confirm" (click)="callDriver(callDialogNumber!)">Call</button>
        </div>
    </div>
</div>
